import { createContext, useState, useContext, useEffect } from "react";
import { authService } from "../services/authService";
import dataService from "../services/dataService";
import { useLocation } from "react-router-dom";
import { useStepNavigate } from "../hooks/useStepNavigate";

import { useOrder } from "./OrderContext";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
	const { replaceOrder, resetOrder } = useOrder();
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [requestedPath, setRequestedPath] = useState(null);
	const navigate = useStepNavigate();
	const location = useLocation();

	// useEffect(() => {
	//   const handleAuthRequired = () => {
	//		navigate('/Login');
	//   };

	//   window.addEventListener('auth_required', handleAuthRequired);
	//   return () => window.removeEventListener('auth_required', handleAuthRequired);
	// }, [navigate]);

	// meghívása: window.dispatchEvent(new Event('auth_required'));

	useEffect(() => {
		if (location.pathname !== "/login" && !isAuthenticated && !isLoading) {
			setRequestedPath(location.pathname + location.search);
		}
	}, [location, isAuthenticated, isLoading]);

	useEffect(() => {
		const initAuth = async () => {
			try {
				const isValid = await authService.checkAuth();
				if (!isValid) {
					authService.removeToken();
					setIsAuthenticated(false);
					return;
				}
				setIsAuthenticated(true);

				const hmeliorder_szam = Number(localStorage.getItem("hmeliorder_szam"));
				const step_page = String(localStorage.getItem("step_page"));
				const order = String(localStorage.getItem("order"));
				let orderData = null;
				if (order && order !== "undefined" && order !== "null") {
					orderData = JSON.parse(order);
				} else {
					orderData = null;
				}

				if (hmeliorder_szam) {
					if (hmeliorder_szam === 1) {
						// az, hogy itt a rendelést visszatöltjük localstorage-ból, az csak akkor jöhet elő, ha még nem volt mentve a rendelés igazából
						// így ez legfőképpen a fejlesztés allati navigálások miatt van
						// mert egyébként a hmeliorder_szam már nem 1-es lenne a mentés miatt
						// if (orderData !== null) {
						// 	// const orderData = JSON.parse(order);
						// 	replaceOrder(orderData);
						// 	if (step_page && step_page !== "undefined" && step_page !== "null") {
						// 		navigate("/" + step_page);
						// 	} else {
						// 		navigate("/MeretfelveteliHely");
						// 	}
						// } else {
							resetOrder();
							navigate("/MeretfelveteliHely");
						// }
					} else {
						try {
							const response = await dataService.getOrder(hmeliorder_szam, orderData.partner.partner_szam);

							// TODO ide fel kell venni azt, hogy melyik státusznál melyik oldalra kell irányítani, ha egyáltalán kitalálható
							// figyelembe vesszük a step_page-at, de felülírjuk, ha a rendelés státusza ezt nem engedné már meg

							if (response?.status !== 200) {
								throw new Error("Rendelés lekérése sikertelen");
							}
							const freshOrderData = response.data.data;
							// debugger;
							if (!freshOrderData || !freshOrderData.hmeliorder) {
								throw new Error("Rendelés adatai nem találhatóak");
							}
							replaceOrder(freshOrderData);
							// debugger;
							if (step_page && step_page !== "undefined" && step_page !== "null") {
								navigate("/" + step_page);
							} else {
								navigate("/Home");
							}
						} catch (error) {
							localStorage.setItem("hmeliorder_szam", 1);
							console.error("Rendelés lekérése sikertelen:", error);
							resetOrder();
							navigate("/Home");
							return;
						}
					}
				} else {
					resetOrder();
					console.log("bejelentkezésnél reseteltem");
					navigate("/Home");
				}
				// if (requestedPath) {
				//   navigate(requestedPath);
				//   setRequestedPath(null);
				// }
			} catch (error) {
				console.error("Auth check failed:", error);
			} finally {
				setIsLoading(false);
			}
		};
		initAuth();
	}, []);

	const login = () => {
		setIsAuthenticated(true);

		if (requestedPath) {
			navigate(requestedPath);
			setRequestedPath(null);
		}
	};

	const logout = async () => {
		// await authService.logout();
		setIsAuthenticated(false);
	};

	if (isLoading) {
		return <div>Betöltés ...</div>;
	}

	return (
		<AuthContext.Provider
			value={{
				isAuthenticated,
				login,
				logout,
				setRequestedPath,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
